import React from 'react';

import { SVGComponentProps } from './svg.types';

const AIButtonStarsSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <path
          d="M4.29283 2.55605C4.47261 1.81465 5.52706 1.81465 5.70684 2.55605L6.20152 4.59608C6.26571 4.86079 6.47238 5.06746 6.73709 5.13165L8.77712 5.62633C9.51852 5.80611 9.51852 6.86056 8.77712 7.04034L6.73709 7.53501C6.47238 7.5992 6.26571 7.80588 6.20152 8.07058L5.70684 10.1106C5.52706 10.852 4.47261 10.852 4.29283 10.1106L3.79816 8.07058C3.73397 7.80588 3.52729 7.5992 3.26259 7.53501L1.22256 7.04034C0.481152 6.86056 0.481152 5.80611 1.22256 5.62633L3.26259 5.13165C3.52729 5.06746 3.73397 4.86079 3.79815 4.59608L4.29283 2.55605Z"
          fill="url(#paint0_linear_265_1296)"
        />
        <path
          d="M10.2314 9.67552C10.3421 9.21927 10.991 9.21927 11.1016 9.67552L11.406 10.9309C11.4455 11.0938 11.5727 11.221 11.7356 11.2605L12.991 11.5649C13.4472 11.6756 13.4472 12.3244 12.991 12.4351L11.7356 12.7395C11.5727 12.779 11.4455 12.9062 11.406 13.0691L11.1016 14.3245C10.991 14.7807 10.3421 14.7807 10.2314 14.3245L9.92701 13.0691C9.88751 12.9062 9.76032 12.779 9.59743 12.7395L8.34203 12.4351C7.88578 12.3244 7.88578 11.6756 8.34203 11.5649L9.59743 11.2605C9.76032 11.221 9.88751 11.0938 9.92701 10.9309L10.2314 9.67552Z"
          fill="url(#paint1_linear_265_1296)"
        />
        <path
          d="M12.381 2.47456C12.4536 2.17514 12.8794 2.17514 12.952 2.47456L13.1518 3.29842C13.1777 3.40532 13.2612 3.48878 13.3681 3.5147L14.1919 3.71448C14.4914 3.78708 14.4914 4.21292 14.1919 4.28552L13.3681 4.48529C13.2612 4.51121 13.1777 4.59468 13.1518 4.70158L12.952 5.52544C12.8794 5.82485 12.4536 5.82485 12.381 5.52544L12.1812 4.70158C12.1553 4.59468 12.0718 4.51121 11.9649 4.48529L11.1411 4.28552C10.8417 4.21292 10.8417 3.78708 11.1411 3.71448L11.9649 3.5147C12.0718 3.48878 12.1553 3.40532 12.1812 3.29842L12.381 2.47456Z"
          fill="url(#paint2_linear_265_1296)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.6665 2.62073L12.5035 3.29314C12.4383 3.56192 12.2284 3.77177 11.9596 3.83695L11.2872 4L11.9596 4.16305C12.2284 4.22822 12.4383 4.43808 12.5035 4.70685L12.6665 5.37927L12.8296 4.70685C12.8947 4.43808 13.1046 4.22822 13.3734 4.16305L14.0458 4L13.3734 3.83695C13.1046 3.77177 12.8947 3.56192 12.8296 3.29314L12.6665 2.62073ZM12.9928 2.25664C12.9098 1.91445 12.4232 1.91445 12.3402 2.25664L12.1119 3.19819C12.0823 3.32036 11.9869 3.41575 11.8647 3.44538L10.9231 3.67369C10.581 3.75666 10.581 4.24333 10.9231 4.32631L11.8647 4.55462C11.9869 4.58425 12.0823 4.67963 12.1119 4.8018L12.3402 5.74336C12.4232 6.08554 12.9098 6.08554 12.9928 5.74336L13.2211 4.8018C13.2508 4.67963 13.3461 4.58425 13.4683 4.55462L14.4099 4.32631C14.7521 4.24333 14.7521 3.75666 14.4099 3.67369L13.4683 3.44537C13.3461 3.41575 13.2508 3.32036 13.2211 3.19819L12.9928 2.25664Z"
          fill="url(#paint3_linear_265_1296)"
        />
        <path
          d="M4.6665 15.3333C4.29831 15.3333 3.99984 15.0349 3.99984 14.6667C3.99984 14.2985 4.29831 14 4.6665 14C5.03469 14 5.33317 14.2985 5.33317 14.6667C5.33317 15.0349 5.03469 15.3333 4.6665 15.3333Z"
          fill="url(#paint4_linear_265_1296)"
        />
        <path
          d="M1.33317 12.6667C0.964981 12.6667 0.666504 12.3682 0.666504 12C0.666504 11.6318 0.964981 11.3333 1.33317 11.3333C1.70136 11.3333 1.99984 11.6318 1.99984 12C1.99984 12.3682 1.70136 12.6667 1.33317 12.6667Z"
          fill="url(#paint5_linear_265_1296)"
        />
        <path
          d="M8.6665 2C8.29831 2 7.99984 1.70152 7.99984 1.33333C7.99984 0.965141 8.29831 0.666664 8.6665 0.666664C9.03469 0.666664 9.33317 0.965141 9.33317 1.33333C9.33317 1.70152 9.03469 2 8.6665 2Z"
          fill="url(#paint6_linear_265_1296)"
        />
        <path
          d="M14.6665 9.33333C14.2983 9.33333 13.9998 9.03485 13.9998 8.66666C13.9998 8.29847 14.2983 8 14.6665 8C15.0347 8 15.3332 8.29847 15.3332 8.66666C15.3332 9.03485 15.0347 9.33333 14.6665 9.33333Z"
          fill="url(#paint7_linear_265_1296)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_265_1296"
            x1="0.126153"
            y1="-4.46667"
            x2="16.17"
            y2="-3.76365"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#3D1DFF" />
            <stop offset="0.223953" stopColor="#6147FF" />
            <stop offset="0.46354" stopColor="#D451FF" />
            <stop offset="0.750004" stopColor="#EC458D" />
            <stop offset="1" stopColor="#FFCA8B" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_265_1296"
            x1="0.126153"
            y1="-4.46667"
            x2="16.17"
            y2="-3.76365"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#3D1DFF" />
            <stop offset="0.223953" stopColor="#6147FF" />
            <stop offset="0.46354" stopColor="#D451FF" />
            <stop offset="0.750004" stopColor="#EC458D" />
            <stop offset="1" stopColor="#FFCA8B" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_265_1296"
            x1="0.126153"
            y1="-4.46667"
            x2="16.17"
            y2="-3.76365"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#3D1DFF" />
            <stop offset="0.223953" stopColor="#6147FF" />
            <stop offset="0.46354" stopColor="#D451FF" />
            <stop offset="0.750004" stopColor="#EC458D" />
            <stop offset="1" stopColor="#FFCA8B" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_265_1296"
            x1="0.126153"
            y1="-4.46667"
            x2="16.17"
            y2="-3.76365"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#3D1DFF" />
            <stop offset="0.223953" stopColor="#6147FF" />
            <stop offset="0.46354" stopColor="#D451FF" />
            <stop offset="0.750004" stopColor="#EC458D" />
            <stop offset="1" stopColor="#FFCA8B" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_265_1296"
            x1="0.126153"
            y1="-4.46667"
            x2="16.17"
            y2="-3.76365"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#3D1DFF" />
            <stop offset="0.223953" stopColor="#6147FF" />
            <stop offset="0.46354" stopColor="#D451FF" />
            <stop offset="0.750004" stopColor="#EC458D" />
            <stop offset="1" stopColor="#FFCA8B" />
          </linearGradient>
          <linearGradient
            id="paint5_linear_265_1296"
            x1="0.126153"
            y1="-4.46667"
            x2="16.17"
            y2="-3.76365"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#3D1DFF" />
            <stop offset="0.223953" stopColor="#6147FF" />
            <stop offset="0.46354" stopColor="#D451FF" />
            <stop offset="0.750004" stopColor="#EC458D" />
            <stop offset="1" stopColor="#FFCA8B" />
          </linearGradient>
          <linearGradient
            id="paint6_linear_265_1296"
            x1="0.126153"
            y1="-4.46667"
            x2="16.17"
            y2="-3.76365"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#3D1DFF" />
            <stop offset="0.223953" stopColor="#6147FF" />
            <stop offset="0.46354" stopColor="#D451FF" />
            <stop offset="0.750004" stopColor="#EC458D" />
            <stop offset="1" stopColor="#FFCA8B" />
          </linearGradient>
          <linearGradient
            id="paint7_linear_265_1296"
            x1="0.126153"
            y1="-4.46667"
            x2="16.17"
            y2="-3.76365"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#3D1DFF" />
            <stop offset="0.223953" stopColor="#6147FF" />
            <stop offset="0.46354" stopColor="#D451FF" />
            <stop offset="0.750004" stopColor="#EC458D" />
            <stop offset="1" stopColor="#FFCA8B" />
          </linearGradient>
        </defs>
      </svg>
    </span>
  );
};

export default AIButtonStarsSVG;
